const Gift01 = ({
  size = 20,
  color = 'currentColor',
}: {
  size?: number
  color?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.99996 4.99984V18.3332M9.99996 4.99984H7.05353C6.6194 4.99984 6.20304 4.82424 5.89606 4.51168C5.58908 4.19912 5.41663 3.7752 5.41663 3.33317C5.41663 2.89114 5.58908 2.46722 5.89606 2.15466C6.20304 1.8421 6.6194 1.6665 7.05353 1.6665C9.3452 1.6665 9.99996 4.99984 9.99996 4.99984ZM9.99996 4.99984H12.9464C13.3805 4.99984 13.7969 4.82424 14.1039 4.51168C14.4108 4.19912 14.5833 3.7752 14.5833 3.33317C14.5833 2.89114 14.4108 2.46722 14.1039 2.15466C13.7969 1.8421 13.3805 1.6665 12.9464 1.6665C10.6547 1.6665 9.99996 4.99984 9.99996 4.99984ZM16.6666 9.1665V15.6665C16.6666 16.5999 16.6666 17.0666 16.485 17.4232C16.3252 17.7368 16.0702 17.9917 15.7566 18.1515C15.4001 18.3332 14.9334 18.3332 14 18.3332L5.99996 18.3332C5.06654 18.3332 4.59983 18.3332 4.24331 18.1515C3.9297 17.9917 3.67474 17.7368 3.51495 17.4232C3.33329 17.0666 3.33329 16.5999 3.33329 15.6665L3.33329 9.1665M1.66663 6.33317L1.66663 7.83317C1.66663 8.29988 1.66663 8.53324 1.75745 8.7115C1.83735 8.8683 1.96483 8.99578 2.12163 9.07567C2.29989 9.1665 2.53325 9.1665 2.99996 9.1665L17 9.1665C17.4667 9.1665 17.7 9.1665 17.8783 9.07568C18.0351 8.99578 18.1626 8.8683 18.2425 8.7115C18.3333 8.53324 18.3333 8.29988 18.3333 7.83317V6.33317C18.3333 5.86646 18.3333 5.63311 18.2425 5.45485C18.1626 5.29804 18.0351 5.17056 17.8783 5.09067C17.7 4.99984 17.4667 4.99984 17 4.99984L2.99996 4.99984C2.53325 4.99984 2.29989 4.99984 2.12163 5.09067C1.96483 5.17056 1.83735 5.29804 1.75745 5.45485C1.66663 5.6331 1.66663 5.86646 1.66663 6.33317Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Gift01
